import { BreadcrumbComponentModule } from './../_component/breadcrumb/breadcrumb.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { CommunityPageRoutingModule } from "./community-routing.module";

import { CommunityPage } from "./community.page";
import { HeaderModule } from "../../_component/header/header.module";
import { TranslateModule } from "@ngx-translate/core";
import { CommentModule } from "../_component/comment/comment.module";
import { NoResultModule } from "../_component/no-result/no-result.module";
import { ItemCommunityModule } from "./item-community/item-community.module";
import { SearchBarModule } from "../_component/search-bar/search-bar.module";
import { LoadingStiModule } from "../../_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "../../_directives/shared-directives.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommunityPageRoutingModule,
    HeaderModule,
    TranslateModule,
    CommentModule,
    NoResultModule,
    ItemCommunityModule,
    SearchBarModule,
    LoadingStiModule,
    SharedDirectivesModule,
    BreadcrumbComponentModule
  ],
  declarations: [CommunityPage],
  providers: [],
})
export class CommunityPageModule {}
